<template>
    <div style="width: 100%; height: 100%;">
        <div class="custom-container">
            <div class="d-flex align-center fill-height">
                <v-row style="width: 100%;" align="stretch">
                    <v-col cols="12" md="12">
                        <span class="headline">Willkommen {{user.first_name}} {{user.last_name}}!</span>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-if="$can('show interview own') || $can('create interview employee') || $can('show interview')">
                        <router-link :to="{name: 'EmployeeInterviewsDashboard'}" class="custom-link" style="height: 100%;">
                            <v-hover v-slot:default="{ hover }">
                                <v-card style="height: 100%;" :elevation="hover ? 16 : 2">
                                    <v-card-title class="secondary white--text py-2 d-flex">
                                        <img src="@/assets/employee-interview-white.svg" height="40px" alt="Mitarbeiter-Gepräche" class="mr-2"/>
                                        <div>
                                            <div>Mitarbeitergespräche</div>
                                            <div class="subtitle-2">Personalentwicklung</div>
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        Mit dem Service Mitarbeitergespräch können Führungskräfte und Mitarbeiter die Zusammenfassungen des jährlichen Mitarbeitergesprächs online bequem anlegen, verwalten und einsehen.
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </router-link>
                    </v-col>
                    <v-col cols="12" md="4" v-if="$can('view ideasWorkbench')">
                        <router-link :to="{name: 'IdeasWorkbenchDashboard'}" class="custom-link" style="height: 100%;">
                            <v-hover v-slot:default="{ hover }">
                                <v-card style="height: 100%;" :elevation="hover ? 16 : 2" min-height="200px">
                                    <v-card-title class="secondary white--text py-2 d-flex">
                                        <img src="@/assets/ideas-workbench-white.svg" height="40px" alt="Werkbank" class="mr-2"/>
                                        <div>
                                            <div>WerkBank</div>
                                            <div class="subtitle-2 font-weight-bold">Probieren Sie jetzt aus!</div>
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        Mit der WerkBank können Sie leicht neue Ideen einbringen und gleichzeitig einen Überblick darüber behalten, was gerade gefragt ist.
                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </router-link>

                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-else>
                        <v-card style="height: 100%;" min-height="200px">
                            <v-overlay absolute opacity="0.4" color="white"></v-overlay>
                            <v-card-title class="secondary white--text py-2 d-flex">
                                <img src="@/assets/ideas-workbench-white.svg" height="40px" alt="Werkbank" class="mr-2"/>
                                <div>
                                    <div>WerkBank</div>
                                    <div class="subtitle-2 font-weight-bold">Folgt in Kürze!</div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <!---->
                            </v-card-text>

                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-if="client !== 'Hof'">
                        <v-card style="height: 100%;" min-height="200px">
                            <v-overlay absolute opacity="0.4" color="white"></v-overlay>
                            <v-card-title class="secondary white--text py-2 d-flex">
                                <img src="@/assets/trainee-planning-white.svg" height="40px" alt="Azubiplanung" class="mr-2"/>
                                <div>
                                    <div>Azubiplanung</div>
                                    <div class="subtitle-2 font-weight-bold">Folgt in Kürze!</div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <!---->
                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "user-area-dashboard-content",
        data: () => ({
            user: '',
        }),
        mounted() {
            this.$store.dispatch('user/me').then((response) => {
                this.user = response.data;
            })
        },
      computed: {
        client() {
          return process.env.VUE_APP_CLIENT;
        }
      },
    }
</script>

<style scoped>

</style>
